// Hero background media manifest — shared between HeroStandard (which renders the
// playlist) and ReportMarketingRoute (which preloads the first poster from the
// entry chunk, so the hero's LCP image is already warm while the landing-page JS
// chunk is still downloading). Keep this module dependency-free: importing it must
// never drag the landing-section component graph into the entry bundle.
//
// Add / remove / reorder clips here; drop the .mp4 into public/videos/ first.
// HERO_POSTERS is keyed by the SAME index as HERO_VIDEOS — a real frame (~1s in)
// of each clip, extracted to match 1:1.
//
// CACHE CONTRACT: /videos/** ships with a 30-day Cache-Control header
// (firebase.json + staging/production variants). NEVER replace a clip or
// poster in place under the same filename — returning visitors would see a
// stale file (or a mismatched poster/clip pair) for up to 30 days. New or
// re-cut media gets a NEW filename (e.g. variant-d-hero-v2.mp4 + matching
// -poster-v2.jpg), updated here.
export const HERO_VIDEOS = [
    '/videos/variant-d-hero.mp4',                // Couple planning a home addition
    '/videos/variant-d-adults-construction.mp4', // Adults discussing construction plans
    '/videos/variant-d-family-blueprints.mp4',   // Family reviewing architectural blueprints
    '/videos/variant-d-animate-static.mp4',      // Animated still (source: Animate_static_image_without_cuts)
];

export const HERO_POSTERS = [
    '/videos/variant-d-hero-poster.jpg',
    '/videos/variant-d-adults-construction-poster.jpg',
    '/videos/variant-d-family-blueprints-poster.jpg',
    '/videos/variant-d-animate-static-poster.jpg',
];
